const DEFAULT_DELAY = 20

export const useUpdateTimer = (timerRef, callback, delay=DEFAULT_DELAY) => {
    if (timerRef.current) { clearTimeout(timerRef.current) }
    timerRef.current = setTimeout(callback, delay)
}
